<template>
  <path
    d="M10.688 3.375h2.813v-3.375h-2.813c-2.171 0-3.938 1.766-3.938 3.938v1.688h-2.25v3.375h2.25v9h3.375v-9h2.813l0.563-3.375h-3.375v-1.688c0-0.305 0.258-0.563 0.563-0.563z"
  ></path>
</template>
